module.exports = __webpack_public_path__ + "static/img/average_time_bg.302d9cac.png";